export const isAutomationRole = (roleId?: string) => roleId == "automation";
